import app from '../../app.json'
export const studioVersion = app.expo.version